module.exports = __webpack_public_path__ + "static/media/splash_centro.7a051c75.png";